import React, { Component } from 'react';
import API from '../Api';
import PageLoader from '../components/PageLoader';
import FacebookLogin from 'react-facebook-login';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import { signInWithGoogle } from '../firebase/firebase.utils';
import { auth } from '../firebase/firebase.utils';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
class singup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			param: '',
			title: '',
			loader: 0,
			panel: 2,
			isSuccess: false,
			socialEmail: '',
			SuccessMessage: '',
			isFail: false,
			FailMessage: '',
			isProcessing: false,
			verifyType: 1,
			ErrorMesages: [],
			registerFrom: {
				firstname: '',
				phone: '',
				email: '',
				password: '',
				errors: { firstname: [], email: [], password: [], phone: [] },
				rules: {
					firstname: 'required',
					email: 'required,email',
					password: 'required',
					phone: 'required,number,degit:10'
				}
			},
			loginFrom: {
				phone: '',
				password: '',
				type: 'user',
				errors: { phone: [], password: [] },
				rules: { phone: 'required', password: 'required' }
			},
			forgotForm: {
				phone: '',
				errors: { phone: [] },
				rules: { phone: 'required' }
			},
			VerifyForm: {
				otp: '',
				phone: '',
				errors: { otp: [] },
				rules: { otp: 'required,number,degit:6' }
			},
			changePasswordForm: {
				code: '',
				otp: '',
				password: '',
				errors: { otp: [], password: [] },
				rules: { otp: 'required,number,degit:6', password: 'required' }
			},
			LoginOtpForm: {
				phone: '',
				errors: { phone: [] },
				rules: { phone: 'required,number,degit:10' }
			},
			LoginOtpVerifyForm: {
				type: 3,
				otp: '',
				securestring: '',
				errors: { otp: [] },
				rules: { otp: 'required,number,degit:6' }
			},
			SocialPhoneverifyForm: {
				phone: '',
				errors: { phone: [] },
				rules: { phone: 'required,number,degit:10' }
			},
			SocialPhoneverifywithoptForm: {
				otp: '',
				securestring: '',
				errors: { otp: [] },
				rules: { otp: 'required,number,degit:6' }
			},
			SocialemailverifyForm: {
				email: '',
				errors: { email: [] },
				rules: { email: 'required,email' }
			},
			SocialemailverifywithoptForm: {
				otp: '',
				securestring: '',
				errors: { otp: [] },
				rules: { otp: 'required,number,degit:6' }
			},
			registerSocialFrom: {
				firstname: '',
				phone: '',
				email: '',
				password: '',
				socialLoginid: '',
				socialLogintype: 1,
				type: 4,
				errors: { firstname: [], email: [], password: [], phone: [] },
				rules: {
					firstname: 'required',
					email: 'required,email',
					password: 'required',
					phone: 'required,number,degit:10'
				}
			}
		};
	}

	componentDidMount() {
		const { match: { params } } = this.props;
		console.log(params);
		this.CheckLogin();
		if (params.code) {
			this.setState({ title: 'register', param: params.code }, function () {
				this.verifyEmail();
			});
		} else {
			this.setState({ title: 'register', param: params.cid }, function () { });
		}
		this.unsubscribeFromAuth = auth.onAuthStateChanged((user) => {
			if (user) {
				console.log('user datae', user.providerData);
				this.responseGoogle(user.providerData);
			}
		});
	}
	componentWillUnmount() {
		this.unsubscribeFromAuth();
		auth.signOut();
	}
	CheckLogin() {
		if (localStorage.hasOwnProperty('tocken')) {
			this.props.history.push('/');
		}
	}
	GotoSingin = (e) => {
		this.setState({ panel: 2, isProcessing: false, isSuccess: false, isFail: false });
	};
	GotoSingup = (e) => {
		this.setState({ panel: 1, isProcessing: false, isSuccess: false, isFail: false });
	};
	Gotoforgot = (e) => {
		this.setState({ panel: 3, isProcessing: false, isSuccess: false, isFail: false });
	};
	GotoLoginWithOpt = (e) => {
		this.setState({ panel: 6, isProcessing: false, isSuccess: false, isFail: false });
	};
	Gotoverify = (e) => {
		this.setState({ panel: 4, isProcessing: false, isSuccess: false, isFail: false });
	};
	Gotochange = (e) => {
		this.setState({ panel: 5, isProcessing: false, isSuccess: false, isFail: false });
	};
	updateForm = (name, event) => {
		if (name === 'register') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.registerFrom[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('register', input.name);
			});
		} else if (name === 'login') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.loginFrom[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('login', input.name);
			});
		} else if (name === 'forgot') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.forgotForm[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('forgot', input.name);
			});
		} else if (name === 'verify') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.VerifyForm[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('verify', input.name);
			});
		} else if (name === 'reset') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.changePasswordForm[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('reset', input.name);
			});
		} else if (name === 'loginwithopt') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.LoginOtpForm[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('loginwithopt', input.name);
			});
		} else if (name === 'loginwithoptverify') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.LoginOtpVerifyForm[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('loginwithoptverify', input.name);
			});
		} else if (name === 'SocialPhoneverifyForm') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.SocialPhoneverifyForm[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('SocialPhoneverifyForm', input.name);
			});
		} else if (name === 'SocialPhoneverifywithoptForm') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.SocialPhoneverifywithoptForm[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('SocialPhoneverifywithoptForm', input.name);
			});
		} else if (name === 'SocialemailverifyForm') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.SocialemailverifyForm[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('SocialemailverifyForm', input.name);
			});
		} else if (name === 'SocialemailverifywithoptForm') {
			const input = event.target;
			const value = input.value;
			let statusCopy = Object.assign({}, this.state);
			statusCopy.SocialemailverifywithoptForm[input.name] = value;
			this.setState(statusCopy, () => {
				this.validate('SocialemailverifywithoptForm', input.name);
			});
		}
	};

	validate(formName, inputname) {
		if (formName === 'login') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.loginFrom.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.loginFrom[inputname]);
			statusCopy.loginFrom.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.loginFrom.errors[inputname];
				obj.push(validationReesult);
				statusCopy.loginFrom.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'register') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.registerFrom.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.registerFrom[inputname]);
			statusCopy.registerFrom.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.registerFrom.errors[inputname];
				obj.push(validationReesult);
				statusCopy.registerFrom.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'forgot') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.forgotForm.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.forgotForm[inputname]);
			statusCopy.forgotForm.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.forgotForm.errors[inputname];
				obj.push(validationReesult);
				statusCopy.forgotForm.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'verify') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.VerifyForm.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.VerifyForm[inputname]);
			statusCopy.VerifyForm.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.VerifyForm.errors[inputname];
				obj.push(validationReesult);
				statusCopy.VerifyForm.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'reset') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.changePasswordForm.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.changePasswordForm[inputname]);
			statusCopy.changePasswordForm.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.changePasswordForm.errors[inputname];
				obj.push(validationReesult);
				statusCopy.changePasswordForm.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'loginwithopt') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.LoginOtpForm.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.LoginOtpForm[inputname]);
			statusCopy.LoginOtpForm.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.LoginOtpForm.errors[inputname];
				obj.push(validationReesult);
				statusCopy.LoginOtpForm.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'loginwithoptverify') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.LoginOtpVerifyForm.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.LoginOtpVerifyForm[inputname]);
			statusCopy.LoginOtpVerifyForm.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.LoginOtpVerifyForm.errors[inputname];
				obj.push(validationReesult);
				statusCopy.LoginOtpVerifyForm.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'SocialPhoneverifyForm') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.SocialPhoneverifyForm.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.SocialPhoneverifyForm[inputname]);
			statusCopy.SocialPhoneverifyForm.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.SocialPhoneverifyForm.errors[inputname];
				obj.push(validationReesult);
				statusCopy.SocialPhoneverifyForm.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'SocialPhoneverifywithoptForm') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.SocialPhoneverifywithoptForm.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.SocialPhoneverifywithoptForm[inputname]);
			statusCopy.SocialPhoneverifywithoptForm.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.SocialPhoneverifywithoptForm.errors[inputname];
				obj.push(validationReesult);
				statusCopy.SocialPhoneverifywithoptForm.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'SocialemailverifyForm') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.SocialemailverifyForm.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.SocialemailverifyForm[inputname]);
			statusCopy.SocialemailverifyForm.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.SocialemailverifyForm.errors[inputname];
				obj.push(validationReesult);
				statusCopy.SocialemailverifyForm.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		} else if (formName === 'SocialemailverifywithoptForm') {
			let statusCopy = Object.assign({}, this.state);
			let rule = statusCopy.SocialemailverifywithoptForm.rules;
			let rules = rule[inputname].split(',');
			let validationReesult = this.validations(rules, statusCopy.SocialemailverifywithoptForm[inputname]);
			statusCopy.SocialemailverifywithoptForm.errors[inputname] = [];
			if (validationReesult) {
				let obj = statusCopy.SocialemailverifywithoptForm.errors[inputname];
				obj.push(validationReesult);
				statusCopy.SocialemailverifywithoptForm.errors[inputname] = obj;
			}
			this.setState(statusCopy);
		}
	}

	validations(Rule, data) {
		for (let index = 0; index < Rule.length; index++) {
			const element = Rule[index];
			const ruleValues = element.split(':');
			switch (ruleValues[0]) {
				case 'required':
					if (!data) {
						return 'Field is Required';
					}
					if (data.length === 0) {
						return 'Field is Required';
					}
					break;
				case 'email':
					if (!data.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
						return 'Field value is not valid email';
					}
					break;
				case 'number':
					if (!data.match(/[0-9]/g)) {
						return 'Field value is must be number';
					}
					break;
				case 'degit':
					const dd = parseInt(ruleValues[1]);
					if (data.length !== dd) {
						return 'Field value is must be ' + dd + ' degit';
					}
					break;
				default:
					break;
			}
		}
	}

	verifyEmail() {
		this.setState({ isProcessing: true, isSuccess: false, isFail: false });
		API.get(`users/verify/user/email/` + this.state.param)
			.then((res) => {
				this.setState({ isProcessing: false, isSuccess: false, isFail: false });
				if (res.data.status === 200) {
					ToastsStore.success(res.data.message, 5000);
				} else if (res.data.status === 201) {
					ToastsStore.error(res.data.message, 5000);
				} else {
					ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
				}
			})
			.catch((error) => {
				this.setState({ isProcessing: false, isSuccess: false, isFail: false });
				ToastsStore.error('Something went wrong try after some time!', 5000);
				// Error
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					// console.log(error.response.data);
					//console.log(error.response.status);
					// console.log(error.response.headers);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
				}
				console.log(error.config);
			});
	}

	reSend = (e) => {
		this.setState({ isProcessing: true, isSuccess: false, isFail: false });
		API.post(`users/resend/otp`, this.state.VerifyForm)
			.then((res) => {
				this.setState({ isProcessing: false, isSuccess: false, isFail: false });
				if (res.data.status === 200) {
					ToastsStore.success(res.data.message, 5000);
				} else if (res.data.status === 201) {
					ToastsStore.error(res.data.message, 5000);
				} else {
					ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
				}
			})
			.catch((error) => {
				this.setState({ isProcessing: false, isSuccess: false, isFail: false });
				ToastsStore.error('Something went wrong try after some time!', 5000);
				// Error
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					// console.log(error.response.data);
					//console.log(error.response.status);
					// console.log(error.response.headers);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
				}
				console.log(error.config);
			});
	};

	submitForm = (name, event) => {
		event.preventDefault();
		if (name === 'register') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`users/register/store`, this.state.registerFrom)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						ToastsStore.success(res.data.message, 5000);
						let statusCopy = Object.assign({}, this.state);
						statusCopy.registerFrom.email = '';
						statusCopy.registerFrom.firstname = '';
						statusCopy.registerFrom.password = '';
						statusCopy.VerifyForm.phone = this.state.registerFrom.phone;
						statusCopy.registerFrom.phone = '';
						this.setState(statusCopy);
						this.Gotoverify();
					} else if (res.data.status === 201) {
						ToastsStore.error(res.data.message, 5000);
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'login') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`login`, this.state.loginFrom)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status) {
						ToastsStore.success('Login Successfully', 5000);
						localStorage.setItem('tocken', res.data.access_token);
						window.location.href = '/cart';
					} else {
						if (
							res.data.error === 'Your mobile number is not verified, OTP sent on you mobile.'
						) {
							let statusCopy = Object.assign({}, this.state);
							statusCopy.VerifyForm.phone = this.state.loginFrom.phone;
							ToastsStore.error(res.data.error, 5000);
							this.setState(statusCopy, () => {
								setTimeout(
									function () {
										this.Gotoverify();
									}.bind(this),
									2000
								);
							});
						} else {
							ToastsStore.error(res.data.error, 5000);
						}
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'forgot') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`users/forgot/password`, this.state.forgotForm)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						ToastsStore.success(res.data.message, 5000);
						let statusCopy = Object.assign({}, this.state);
						statusCopy.forgotForm.phone = '';

						statusCopy.VerifyForm.phone = this.state.forgotForm.phone;
						statusCopy.changePasswordForm.code = res.data.data;
						this.setState(statusCopy, function () {
							setTimeout(
								function () {
									this.Gotochange();
								}.bind(this),
								5000
							);
						});
					} else if (res.data.status === 201) {
						ToastsStore.error(res.data.message, 5000);
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'verify') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`users/verify/user`, this.state.VerifyForm)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						let statusCopy = Object.assign({}, this.state);
						statusCopy.VerifyForm.phone = '';
						statusCopy.VerifyForm.otp = '';
						this.setState(statusCopy, function () {
							setTimeout(
								function () {
									this.GotoSingin();
								}.bind(this),
								5000
							);
						});
						ToastsStore.success(res.data.message, 5000);
					} else if (res.data.status === 201) {
						ToastsStore.error(res.data.message, 5000);
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'reset') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`users/forgot/password/update`, this.state.changePasswordForm)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						ToastsStore.success(res.data.message, 5000);
						let statusCopy = Object.assign({}, this.state);
						statusCopy.changePasswordForm.code = '';
						statusCopy.VerifyForm.otp = '';
						statusCopy.VerifyForm.phone = '';

						this.setState(statusCopy, function () { });
					} else if (res.data.status === 201) {
						ToastsStore.error(res.data.message, 5000);
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'loginwithopt') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`users/login/with/opt`, this.state.LoginOtpForm)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						let statusCopy = Object.assign({}, this.state);
						statusCopy.LoginOtpForm.phone = '';
						statusCopy.isSuccess = true;
						statusCopy.SuccessMessage = res.data.message;
						statusCopy.panel = 7;
						statusCopy.LoginOtpVerifyForm.securestring = res.data.data;
						this.setState(statusCopy);
					} else if (res.data.status === 201) {
						ToastsStore.error(res.data.message, 5000);
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'loginwithoptverify') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`login`, this.state.LoginOtpVerifyForm)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status) {
						ToastsStore.success('Login Successfully', 5000);
						localStorage.setItem('tocken', res.data.access_token);
						window.location.href = '/cart';
					} else {
						if (
							res.data.error === 'Your mobile number is not verified, OTP sent on you mobile.'
						) {
							let statusCopy = Object.assign({}, this.state);
							statusCopy.VerifyForm.phone = this.state.loginFrom.phone;
							ToastsStore.error(res.data.error, 5000);
							this.setState(statusCopy, () => {
								setTimeout(
									function () {
										this.Gotoverify();
									}.bind(this),
									2000
								);
							});
						} else {
							ToastsStore.error(res.data.error, 5000);
						}
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'SocialPhoneverifyForm') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`users/check/phone/social`, this.state.SocialPhoneverifyForm)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						ToastsStore.success(res.data.message, 5000);
						let statusCopy = Object.assign({}, this.state);
						statusCopy.panel = 9;
						statusCopy.SocialPhoneverifywithoptForm.securestring = res.data.data;
						this.setState(statusCopy);
					} else if (res.data.status === 201) {
						ToastsStore.error(res.data.message, 5000);
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'SocialPhoneverifywithoptForm') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`users/check/phone/social/verify`, this.state.SocialPhoneverifywithoptForm)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						if (this.state.socialEmail) {
							ToastsStore.success(res.data.message, 5000);
							let statusCopy = Object.assign({}, this.state);

							statusCopy.registerSocialFrom.email = this.state.socialEmail;
							statusCopy.registerSocialFrom.phone = this.state.SocialPhoneverifyForm.phone;
							this.setState(statusCopy, function () {
								API.post(`login`, this.state.registerSocialFrom)
									.then((reslogin) => {
										if (reslogin.data.status) {
											ToastsStore.success('Login Successfully', 5000);
											localStorage.setItem('tocken', reslogin.data.access_token);
											window.location.href = '/cart';
										} else {
											let erroritem = [];
											if (
												reslogin.data.error ===
												'Your mobile number is not verified, OTP sent on you mobile'
											) {
												ToastsStore.error(reslogin.data.error, 5000);
												erroritem.push(reslogin.data.error);
												let statusCopy = Object.assign({}, this.state);
												statusCopy.VerifyForm.phone = this.state.loginFrom.phone;

												this.setState(statusCopy, () => {
													setTimeout(
														function () {
															this.Gotoverify();
														}.bind(this),
														2000
													);
												});
											} else {
												ToastsStore.error(reslogin.data.error, 5000);
											}
										}
									})
									.catch((error) => {
										ToastsStore.error('Something went wrong try after some time!', 5000);
										// Error
										if (error.response) {
											// The request was made and the server responded with a status code
											// that falls out of the range of 2xx
											// console.log(error.response.data);
											//console.log(error.response.status);
											// console.log(error.response.headers);
										} else if (error.request) {
											// The request was made but no response was received
											// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
											// http.ClientRequest in node.js
											console.log(error.request);
										} else {
											// Something happened in setting up the request that triggered an Error
											console.log('Error', error.message);
										}
										console.log(error.config);
									});
							});
						} else {
							ToastsStore.success(res.data.message, 5000);
							let statusCopy = Object.assign({}, this.state);

							statusCopy.panel = 10;

							statusCopy.registerSocialFrom.phone = this.state.SocialPhoneverifyForm.phone;
							this.setState(statusCopy);
						}

						//login code
					} else if (res.data.status === 201) {
						ToastsStore.error(res.data.message, 5000);
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'SocialemailverifyForm') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`users/check/email/social`, this.state.SocialemailverifyForm)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						ToastsStore.success(res.data.message, 5000);
						let statusCopy = Object.assign({}, this.state);
						statusCopy.panel = 11;
						statusCopy.SocialemailverifywithoptForm.securestring = res.data.data;
						this.setState(statusCopy);
					} else if (res.data.status === 201) {
						ToastsStore.error(res.data.message, 5000);
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		} else if (name === 'SocialemailverifywithoptForm') {
			this.setState({ isProcessing: true, isSuccess: false, isFail: false });
			API.post(`users/check/email/social/verify`, this.state.SocialemailverifywithoptForm)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						ToastsStore.success(res.data.message, 5000);
						let statusCopy = Object.assign({}, this.state);
						statusCopy.registerSocialFrom.email = this.state.SocialemailverifyForm.email;
						this.setState(statusCopy, function () {
							API.post(`login`, this.state.registerSocialFrom)
								.then((reslogin) => {
									if (reslogin.data.status) {
										ToastsStore.success('Login Successfully', 5000);

										localStorage.setItem('tocken', reslogin.data.access_token);
										window.location.href = '/cart';
									} else {
										let erroritem = [];
										if (
											reslogin.data.error ===
											'Your mobile number is not verified, OTP sent on you mobile'
										) {
											ToastsStore.error(reslogin.data.error, 5000);
											let statusCopy = Object.assign({}, this.state);
											statusCopy.VerifyForm.phone = this.state.loginFrom.phone;

											this.setState(statusCopy, () => {
												setTimeout(
													function () {
														this.Gotoverify();
													}.bind(this),
													2000
												);
											});
										} else {
											ToastsStore.error(reslogin.data.error, 5000);
										}
									}
								})
								.catch((error) => {
									this.setState({ isProcessing: false, isSuccess: false, isFail: false });
									ToastsStore.error('Something went wrong try after some time!', 5000);
									// Error
									if (error.response) {
										// The request was made and the server responded with a status code
										// that falls out of the range of 2xx
										// console.log(error.response.data);
										//console.log(error.response.status);
										// console.log(error.response.headers);
									} else if (error.request) {
										// The request was made but no response was received
										// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
										// http.ClientRequest in node.js
										console.log(error.request);
									} else {
										// Something happened in setting up the request that triggered an Error
										console.log('Error', error.message);
									}
									console.log(error.config);
								});
						});
						//login code
					} else if (res.data.status === 201) {
						ToastsStore.error(res.data.message, 5000);
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		}
	};
	responseFacebook = (response) => {
		console.log(response);
		let statusCopy = Object.assign({}, this.state);
		if (response.userID) {
			statusCopy.registerSocialFrom.socialLoginid = response.userID;
			statusCopy.registerSocialFrom.socialLogintype = 2;
			statusCopy.registerSocialFrom.firstname = response.name;
			if (response.email) {
				statusCopy.socialEmail = response.email;
			} else {
				statusCopy.socialEmail = undefined;
			}

			this.setState(statusCopy);
			API.get(`users/check/social/user/` + response.userID)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						ToastsStore.success(res.data.message, 5000);
						API.post(`login`, this.state.registerSocialFrom)
							.then((reslogin) => {
								if (reslogin.data.status) {
									ToastsStore.success('Login Successfully', 5000);

									localStorage.setItem('tocken', reslogin.data.access_token);
									window.location.href = '/cart';
								} else {
									let erroritem = [];
									if (
										reslogin.data.error ===
										'Your mobile number is not verified, OTP sent on you mobile.'
									) {
										ToastsStore.error(reslogin.data.error, 5000);
										let statusCopy = Object.assign({}, this.state);
										statusCopy.VerifyForm.phone = this.state.loginFrom.phone;
										this.setState(statusCopy, () => {
											setTimeout(
												function () {
													this.Gotoverify();
												}.bind(this),
												2000
											);
										});
									} else {
										ToastsStore.error(reslogin.data.error, 5000);
									}
								}
							})
							.catch((error) => {
								this.setState({ isProcessing: false, isSuccess: false, isFail: false });
								ToastsStore.error('Something went wrong try after some time!', 5000);
								// Error
								if (error.response) {
									// The request was made and the server responded with a status code
									// that falls out of the range of 2xx
									// console.log(error.response.data);
									//console.log(error.response.status);
									// console.log(error.response.headers);
								} else if (error.request) {
									// The request was made but no response was received
									// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
									// http.ClientRequest in node.js
									console.log(error.request);
								} else {
									// Something happened in setting up the request that triggered an Error
									console.log('Error', error.message);
								}
								console.log(error.config);
							});
					} else if (res.data.status === 201) {
						this.setState({ panel: 8 });
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		}
		//name email userID
	};
	responseGoogle = (response) => {
		console.log(response.profileObj);
		let statusCopy = Object.assign({}, this.state);
		if (response[0].displayName) {
			statusCopy.registerSocialFrom.socialLoginid = response[0].uid;
			statusCopy.registerSocialFrom.firstname = response[0].displayName;
			statusCopy.registerSocialFrom.socialLogintype = 1;
			if (response[0].email) {
				statusCopy.socialEmail = response[0].email;
			} else {
				statusCopy.socialEmail = undefined;
			}
			this.setState(statusCopy);
			// name; googleId
			API.get(`users/check/social/user/` + response[0].uid)
				.then((res) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					if (res.data.status === 200) {
						ToastsStore.success(res.data.message, 5000);
						API.post(`login`, this.state.registerSocialFrom)
							.then((reslogin) => {
								if (reslogin.data.status) {
									ToastsStore.success('Login Successfully', 5000);

									localStorage.setItem('tocken', reslogin.data.access_token);
									window.location.href = '/cart';
								} else {
									if (
										reslogin.data.error ===
										'Your mobile number is not verified, OTP sent on you mobile.'
									) {
										ToastsStore.error(reslogin.data.error, 5000);

										let statusCopy = Object.assign({}, this.state);
										statusCopy.VerifyForm.phone = this.state.loginFrom.phone;

										this.setState(statusCopy, () => {
											setTimeout(
												function () {
													this.Gotoverify();
												}.bind(this),
												2000
											);
										});
									} else {
										ToastsStore.error(reslogin.data.error, 5000);
									}
								}
							})
							.catch((error) => {
								this.setState({ isProcessing: false, isSuccess: false, isFail: false });
								ToastsStore.error('Something went wrong try after some time!', 5000);
								// Error
								if (error.response) {
									// The request was made and the server responded with a status code
									// that falls out of the range of 2xx
									// console.log(error.response.data);
									//console.log(error.response.status);
									// console.log(error.response.headers);
								} else if (error.request) {
									// The request was made but no response was received
									// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
									// http.ClientRequest in node.js
									console.log(error.request);
								} else {
									// Something happened in setting up the request that triggered an Error
									console.log('Error', error.message);
								}
								console.log(error.config);
							});
					} else if (res.data.status === 201) {
						this.setState({ panel: 8 });
					} else {
						ToastsStore.error(res.data.data.map((item, index) => `${item}`), 5000);
					}
				})
				.catch((error) => {
					this.setState({ isProcessing: false, isSuccess: false, isFail: false });
					ToastsStore.error('Something went wrong try after some time!', 5000);
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(error.response.data);
						//console.log(error.response.status);
						// console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
				});
		}
		// console.log(response.profileobj);
	};
	render() {
		return (
			<div>
				<Helmet>
					<meta property="og:title" content="Online Document Printing Binding Store Delhi India" />
					<meta property="og:type" content="company" />
					<meta
						property="og:description"
						content="India&#39;s first &amp; best online document printing &amp; binding service store. Print out color or black &amp; white PDF documents. Upload Your Document Get Delivery at your Doorstep. Delivered it to anywhere in India."
					/>
					<meta property="og:image" content="
https://printster.in/images/logo.png" />
					<meta property="og:url" content="https://printster.in/" />
					<title>Online Document Printing Binding Store Delhi India Printster</title>
					<meta
						name="description"
						content="Printster is Online document printing &amp; binding services and store. Online Printing for Color Printout or black &amp; white printout with Hard, Wiro, Spiral binding option"
					/>
				</Helmet>
				<ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} lightBackground />
				<PageLoader show={this.state.loader} />
				<section
					id="slider"
					className="slider-parallax full-screen slider-parallax-visible"
					style={{
						background: 'url("/Image/ken-2.jpg") center center',
						overflow: 'visible',
						transform: 'translateY(0px)'
					}}
				>
					<div className="container clearfix ng-scope" ng-controller="SignupFormController">
						<div>
							<div className="row">
								<div className="col-md-offset-1 col-md-5 col-sm-6 topmargin-sm">
									<div className="panel panel-default" style={{ borderColor: '#eee' }}>
										<div className="panel-body" style={{ padding: 30 }}>
											<div className="heading-block nobottomborder bottommargin-sm">
												{this.state.panel === 1 ? (
													<h1
														style={{ fontSize: 20, textTransform: 'capitalize' }}
														className="ng-hide"
													>
														Register{' '}
													</h1>
												) : (
													''
												)}
												{this.state.panel === 2 ? (
													<h1 style={{ fontSize: 20 }} className="">
														Signin
													</h1>
												) : (
													''
												)}
												{this.state.panel === 3 ? (
													<h1 style={{ fontSize: 20 }} className="ng-hide">
														Forget Password
													</h1>
												) : (
													''
												)}
												{this.state.panel === 4 ? (
													<h1 style={{ fontSize: 20 }} className="ng-hide">
														Verify Your {this.state.verifyType === 1 ? 'Mobile' : 'Email'}
													</h1>
												) : (
													''
												)}
												{this.state.panel === 5 ? (
													<h1 style={{ fontSize: 20 }} className="ng-hide">
														Change Password
													</h1>
												) : (
													''
												)}
												{this.state.panel === 6 ? (
													<h1 style={{ fontSize: 20 }} className="ng-hide">
														Login with Otp
													</h1>
												) : (
													''
												)}
												{this.state.panel === 7 ? (
													<h1 style={{ fontSize: 20 }} className="ng-hide">
														Verify Otp for login
													</h1>
												) : (
													''
												)}
												{this.state.panel === 8 ? (
													<h1 style={{ fontSize: 20 }} className="ng-hide">
														Verify Phone
													</h1>
												) : (
													''
												)}
												{this.state.panel === 9 ? (
													<h1 style={{ fontSize: 20 }} className="ng-hide">
														Verify Phone with otp
													</h1>
												) : (
													''
												)}
												{this.state.panel === 10 ? (
													<h1 style={{ fontSize: 20 }} className="ng-hide">
														Verify email
													</h1>
												) : (
													''
												)}
												{this.state.panel === 11 ? (
													<h1 style={{ fontSize: 20 }} className="ng-hide">
														Verify email with opt
													</h1>
												) : (
													''
												)}
											</div>
											{this.state.isProcessing ? (
												<div className="style-msg infomsg ng-hide">
													<div className="sb-msg ng-binding">
														{' '}
														<img src="/Image/hourglass.gif" alt="loading" />
														<i className="icon-remove" />
														<strong>Processing!</strong>{' '}
													</div>
												</div>
											) : (
												''
											)}

											{this.state.panel === 1 ? (
												<form
													onSubmit={this.submitForm.bind(this, 'register')}
													className="clearfix"
												>
													<div className="col_full">
														Full Name
														<input
															type="text"
															id="signupname"
															placeholder="You're Person to us, not a set of initials"
															name="firstname"
															className="required form-control  not-dark"
															required="required"
															value={this.state.registerFrom.firstname}
															onChange={this.updateForm.bind(this, 'register')}
														/>
														{this.state.registerFrom.errors['firstname'] ? (
															<span className="small t700 text-danger">
																{this.state.registerFrom.errors['firstname']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full">
														Mobile Number
														<input
															type="text"
															name="phone"
															maxLength="10"
															min="1000000000"
															max="9999999999"
															placeholder="So, we know how to reach you :) (10 Digit)"
															className="required form-control  not-dark ng-pristine"
															required="required"
															value={this.state.registerFrom.phone}
															onChange={this.updateForm.bind(this, 'register')}
														/>
														{this.state.registerFrom.errors['phone'] ? (
															<span className="small t700 text-danger">
																{this.state.registerFrom.errors['phone']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full">
														Emails
														<input
															type="email"
															name="email"
															placeholder="To keep you up-to-speed with orders"
															className="required form-control  not-dark "
															required="required"
															value={this.state.registerFrom.email}
															onChange={this.updateForm.bind(this, 'register')}
														/>
														{this.state.registerFrom.errors['email'] ? (
															<span className="small t700 text-danger">
																{this.state.registerFrom.errors['email']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full">
														Password
														<input
															type="password"
															name="password"
															placeholder="That Thing used to Login"
															className="required form-control  not-dark"
															required="required"
															value={this.state.registerFrom.password}
															onChange={this.updateForm.bind(this, 'register')}
														/>
														{this.state.registerFrom.errors['password'] ? (
															<span className="small t700 text-danger">
																{this.state.registerFrom.errors['password']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin center">
														<small>
															By continuing with Signup I agree to
															<Link to={''} style={{ padding: 0 }}>
																{' '}
																&nbsp; Terms &amp; Conditions{' '}
															</Link>
														</small>
													</div>
													<br />
													<div className="col_full nobottommargin center">
														<button
															type="submit"
															id="login-form-submit"
															name="login-form-submit"
															className="t400 capitalize btn btn-primary nomargin"
															ng-disabled="!SignupForm.$valid"
															value="submit"
														>
															Signup Now
														</button>
													</div>
													<div className="col_full nobottommargin nobtn">
														<h3 class="loginwith">
															<span>or login with</span>{' '}
														</h3>

														<FacebookLogin
															appId="3158409407718379"
															fields="name,email,picture"
															callback={this.responseFacebook}
															cssClass="loginBtn loginBtn--facebook"
														/>
														<button
															className="loginBtn loginBtn--google"
															onClick={() => {
																signInWithGoogle();
															}}
														>
															Login with Google
														</button>
														{/* <GoogleLogin
															clientId="335270423838-i4jp59v495nhhjc6314nn9ctqsakglbh.apps.googleusercontent.com"
															buttonText="Login with Google"
															onSuccess={this.responseGoogle}
															onFailure={this.responseGoogle}
															render={(renderProps) => (
																<button
																	className="loginBtn loginBtn--google"
																	onClick={renderProps.onClick}
																	disabled={renderProps.disabled}
																>
																	Login with Google
																</button>
															)}
														/> */}
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 2 ? (
												<form
													onSubmit={this.submitForm.bind(this, 'login')}
													className="ng-scope"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															Email or Mobile
														</label>
														<input
															type="text"
															name="phone"
															placeholder="Email ID or Mobile"
															className="required form-control  not-dark"
															required="required"
															value={this.state.loginFrom.phone}
															validate="required"
															onChange={this.updateForm.bind(this, 'login')}
														/>
														{this.state.loginFrom.errors['phone'] ? (
															<span className="small t700 text-danger">
																{this.state.loginFrom.errors['phone']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															Password
														</label>
														<input
															type="password"
															name="password"
															placeholder="Password"
															className="required form-control  not-dark"
															required="required"
															value={this.state.loginFrom.password}
															onChange={this.updateForm.bind(this, 'login')}
														/>
														{this.state.loginFrom.errors['password'] ? (
															<span className="small t700 text-danger">
																{this.state.loginFrom.errors['password']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="login-form-submit"
															className="t400 capitalize btn btn-primary nomargin"
															value="submit"
														>
															Login Now
														</button>
														<span className="SpanHref fright" onClick={this.Gotoforgot}>
															Forgot Password?
														</span>
														<br />
														<span
															className="SpanHref fright"
															onClick={this.GotoLoginWithOpt}
														>
															Login With OTP
														</span>
													</div>

													<div className="col_full nobottommargin nobtn">
														<h3 class="loginwith">
															<span>or login with</span>{' '}
														</h3>
														<FacebookLogin
															appId="3158409407718379"
															fields="name,email,picture"
															callback={this.responseFacebook}
															cssClass="loginBtn loginBtn--facebook"
														/>
														<button
															className="loginBtn loginBtn--google"
															onClick={() => {
																signInWithGoogle();
															}}
														>
															Login with Google
														</button>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 3 ? (
												<form
													id="loginbox"
													onSubmit={this.submitForm.bind(this, 'forgot')}
													className="ng-scope"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															Email or Mobile
														</label>
														<input
															type="text"
															name="phone"
															id="siginusername"
															placeholder="Email ID or Mobile"
															className="required form-control  not-dark ng-pristine ng-invalid ng-invalid-required"
															required="required"
															value={this.state.forgotForm.phone}
															onChange={this.updateForm.bind(this, 'forgot')}
														/>
														{this.state.forgotForm.errors['phone'] ? (
															<span className="small t700 text-danger">
																{this.state.forgotForm.errors['phone']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="forget-form-submit"
															name="forget-form-submit"
															className="btn btn-primary nomargin"
															ng-click="forgetpass();"
															value="submit"
														>
															Check Account
														</button>
														<span className="SpanHref fright" onClick={this.GotoSingin}>
															{' '}
															Login{' '}
														</span>
														<span
															className="SpanHref fright"
															style={{ paddingRight: 10 }}
															onClick={this.GotoSingup}
														>
															{' '}
															Register{' '}
														</span>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 4 ? (
												<form
													id="loginbox"
													onSubmit={this.submitForm.bind(this, 'verify')}
													className="ng-pristine"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															One Time Password (OTP)
														</label>
														<input
															type="number"
															name="otp"
															placeholder="Enter 6 Digit OTP"
															min="0"
															max="999999"
															maxLength="4"
															pattern="\d{4}"
															ng-model="verify.otp"
															className="required form-control  not-dark"
															required="required"
															value={this.state.VerifyForm.otp}
															onChange={this.updateForm.bind(this, 'verify')}
														/>
														{this.state.VerifyForm.errors['otp'] ? (
															<span className="small t700 text-danger">
																{this.state.VerifyForm.errors['otp']}
															</span>
														) : (
															''
														)}
														<span
															className="withoutSpanherf small t700 text-success"
															onClick={this.reSend}
														>
															Resend OTP.
														</span>
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="forget-form-submit"
															name="forget-form-submit"
															className="t400 capitalize btn btn-primary nomargin"
															value="submit"
														>
															Confirm Registration
														</button>
														<span className="SpanHref fright" onClick={this.GotoSingin}>
															{' '}
															Login{' '}
														</span>
														<span
															className="SpanHref fright"
															style={{ paddingRight: 10 }}
															onClick={this.GotoSingup}
														>
															{' '}
															Register{' '}
														</span>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 5 ? (
												<form
													id="loginbox"
													onSubmit={this.submitForm.bind(this, 'reset')}
													className="ng-pristine"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															One Time Password (OTP)
														</label>
														<input
															type="text"
															name="otp"
															placeholder="Enter 6 Digit OTP"
															min="0"
															max="999999"
															maxLength="6"
															pattern="\d{6}"
															className="required form-control  not-dark ng-pristine ng-invalid ng-invalid-required"
															required="required"
															value={this.state.changePasswordForm.otp}
															onChange={this.updateForm.bind(this, 'reset')}
														/>
														{this.state.changePasswordForm.errors['otp'] ? (
															<span className="small t700 text-danger">
																{this.state.changePasswordForm.errors['otp']}
															</span>
														) : (
															''
														)}
														<span
															className="withoutSpanherf small t700 text-success"
															onClick={this.reSend}
														>
															Resend OTP.
														</span>
													</div>
													<div className="col_full">
														Enter New Password
														<input
															type="password"
															name="password"
															id="resetpassword"
															placeholder="Password"
															ng-required="true"
															ng-model="resetf.password"
															className="required form-control  not-dark ng-pristine ng-invalid ng-invalid-required"
															required="required"
															value={this.state.changePasswordForm.password}
															onChange={this.updateForm.bind(this, 'reset')}
														/>
														{this.state.changePasswordForm.errors['password'] ? (
															<span className="small t700 text-danger">
																{this.state.changePasswordForm.errors['password']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="forget-form-submit"
															name="forget-form-submit"
															className="t400 capitalize btn btn-primary nomargin"
															ng-click="ResetAccount();"
														>
															Change Password
														</button>
														<span className="SpanHref fright" onClick={this.GotoSingin}>
															{' '}
															Login{' '}
														</span>
														<span
															className="SpanHref fright"
															style={{ paddingRight: 10 }}
															onClick={this.GotoSingup}
														>
															{' '}
															Register{' '}
														</span>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 6 ? (
												<form
													id="loginbox"
													onSubmit={this.submitForm.bind(this, 'loginwithopt')}
													className="ng-scope"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															Mobile
														</label>
														<input
															type="text"
															name="phone"
															id="siginusername"
															placeholder="Mobile"
															className="required form-control  not-dark ng-pristine ng-invalid ng-invalid-required"
															required="required"
															value={this.state.LoginOtpForm.phone}
															onChange={this.updateForm.bind(this, 'loginwithopt')}
														/>
														{this.state.LoginOtpForm.errors['phone'] ? (
															<span className="small t700 text-danger">
																{this.state.LoginOtpForm.errors['phone']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="forget-form-submit"
															name="forget-form-submit"
															className="btn btn-primary nomargin"
															ng-click="forgetpass();"
															value="submit"
														>
															Check Account
														</button>
														<span className="SpanHref fright" onClick={this.GotoSingin}>
															{' '}
															Login{' '}
														</span>
														<span
															className="SpanHref fright"
															style={{ paddingRight: 10 }}
															onClick={this.GotoSingup}
														>
															{' '}
															Register{' '}
														</span>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 7 ? (
												<form
													id="loginbox"
													onSubmit={this.submitForm.bind(this, 'loginwithoptverify')}
													className="ng-scope"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															Otp
														</label>
														<input
															type="text"
															name="otp"
															id="siginusername"
															placeholder="Otp"
															className="required form-control  not-dark ng-pristine ng-invalid ng-invalid-required"
															required="required"
															value={this.state.LoginOtpVerifyForm.otp}
															onChange={this.updateForm.bind(this, 'loginwithoptverify')}
														/>
														{this.state.LoginOtpVerifyForm.errors['otp'] ? (
															<span className="small t700 text-danger">
																{this.state.LoginOtpVerifyForm.errors['otp']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="forget-form-submit"
															name="forget-form-submit"
															className="btn btn-primary nomargin"
															ng-click="forgetpass();"
															value="submit"
														>
															Login
														</button>
														<span className="SpanHref fright" onClick={this.GotoSingin}>
															{' '}
															Login{' '}
														</span>
														<span
															className="SpanHref fright"
															style={{ paddingRight: 10 }}
															onClick={this.GotoSingup}
														>
															{' '}
															Register{' '}
														</span>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 8 ? (
												<form
													id="loginbox"
													onSubmit={this.submitForm.bind(this, 'SocialPhoneverifyForm')}
													className="ng-scope"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															Mobile
														</label>
														<input
															type="text"
															name="phone"
															id="siginusername"
															placeholder="Mobile"
															className="required form-control  not-dark ng-pristine ng-invalid ng-invalid-required"
															required="required"
															value={this.state.SocialPhoneverifyForm.phone}
															onChange={this.updateForm.bind(
																this,
																'SocialPhoneverifyForm'
															)}
														/>
														{this.state.SocialPhoneverifyForm.errors['phone'] ? (
															<span className="small t700 text-danger">
																{this.state.SocialPhoneverifyForm.errors['phone']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="forget-form-submit"
															name="forget-form-submit"
															className="btn btn-primary nomargin"
															ng-click="forgetpass();"
															value="submit"
														>
															Submit
														</button>
														<span className="SpanHref fright" onClick={this.GotoSingin}>
															{' '}
															Login{' '}
														</span>
														<span
															className="SpanHref fright"
															style={{ paddingRight: 10 }}
															onClick={this.GotoSingup}
														>
															{' '}
															Register{' '}
														</span>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 9 ? (
												<form
													id="loginbox"
													onSubmit={this.submitForm.bind(
														this,
														'SocialPhoneverifywithoptForm'
													)}
													className="ng-scope"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															Otp
														</label>
														<input
															type="text"
															name="otp"
															id="siginusername"
															placeholder="Otp"
															className="required form-control  not-dark ng-pristine ng-invalid ng-invalid-required"
															required="required"
															value={this.state.SocialPhoneverifywithoptForm.otp}
															onChange={this.updateForm.bind(
																this,
																'SocialPhoneverifywithoptForm'
															)}
														/>
														{this.state.SocialPhoneverifywithoptForm.errors['otp'] ? (
															<span className="small t700 text-danger">
																{this.state.SocialPhoneverifywithoptForm.errors['otp']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="forget-form-submit"
															name="forget-form-submit"
															className="btn btn-primary nomargin"
															ng-click="forgetpass();"
															value="submit"
														>
															Login
														</button>
														<span className="SpanHref fright" onClick={this.GotoSingin}>
															{' '}
															Login{' '}
														</span>
														<span
															className="SpanHref fright"
															style={{ paddingRight: 10 }}
															onClick={this.GotoSingup}
														>
															{' '}
															Register{' '}
														</span>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 10 ? (
												<form
													id="loginbox"
													onSubmit={this.submitForm.bind(this, 'SocialemailverifyForm')}
													className="ng-scope"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															Email
														</label>
														<input
															type="text"
															name="email"
															id="siginusername"
															placeholder="Email"
															className="required form-control  not-dark ng-pristine ng-invalid ng-invalid-required"
															required="required"
															value={this.state.SocialemailverifyForm.email}
															onChange={this.updateForm.bind(
																this,
																'SocialemailverifyForm'
															)}
														/>
														{this.state.SocialemailverifyForm.errors['email'] ? (
															<span className="small t700 text-danger">
																{this.state.SocialemailverifyForm.errors['email']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="forget-form-submit"
															name="forget-form-submit"
															className="btn btn-primary nomargin"
															ng-click="forgetpass();"
															value="submit"
														>
															Submit
														</button>
														<span className="SpanHref fright" onClick={this.GotoSingin}>
															{' '}
															Login{' '}
														</span>
														<span
															className="SpanHref fright"
															style={{ paddingRight: 10 }}
															onClick={this.GotoSingup}
														>
															{' '}
															Register{' '}
														</span>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 11 ? (
												<form
													id="loginbox"
													onSubmit={this.submitForm.bind(
														this,
														'SocialemailverifywithoptForm'
													)}
													className="ng-scope"
												>
													<div className="col_full">
														<label htmlFor="" className="capitalize t600">
															Otp
														</label>
														<input
															type="text"
															name="otp"
															id="siginusername"
															placeholder="Otp"
															className="required form-control  not-dark ng-pristine ng-invalid ng-invalid-required"
															required="required"
															value={this.state.SocialemailverifywithoptForm.otp}
															onChange={this.updateForm.bind(
																this,
																'SocialemailverifywithoptForm'
															)}
														/>
														{this.state.SocialemailverifywithoptForm.errors['otp'] ? (
															<span className="small t700 text-danger">
																{this.state.SocialemailverifywithoptForm.errors['otp']}
															</span>
														) : (
															''
														)}
													</div>
													<div className="col_full nobottommargin">
														<button
															type="submit"
															id="forget-form-submit"
															name="forget-form-submit"
															className="btn btn-primary nomargin"
															ng-click="forgetpass();"
															value="submit"
														>
															Login
														</button>
														<span className="SpanHref fright" onClick={this.GotoSingin}>
															{' '}
															Login{' '}
														</span>
														<span
															className="SpanHref fright"
															style={{ paddingRight: 10 }}
															onClick={this.GotoSingup}
														>
															{' '}
															Register{' '}
														</span>
													</div>
												</form>
											) : (
												''
											)}
											{this.state.panel === 2 ? (
												<p className="nobottommargin">
													{' '}
													Don't have an Account?{' '}
													<span className="SpanHref" onClick={this.GotoSingup}>
														<span className="t700">
															<em> Signup Now.</em>
														</span>
													</span>
												</p>
											) : (
												''
											)}
											{this.state.panel === 1 ? (
												<p className="nobottommargin ng-hide">
													{' '}
													<span className="SpanHref" onClick={this.GotoSingin}>
														<span className="t700">
															<em>Click Here to Signin.</em>
														</span>
													</span>
												</p>
											) : (
												''
											)}
										</div>
									</div>
								</div>
								{this.state.panel === 1 ? (
									<div className="col-md-offset-1 col-md-5 col-sm-6 ng-hide">
										<div className="visible-lg visible-md topmargin" />
										<h2>Benefits of Registration</h2>
										<ol>
											<li>
												An Account With us Makes your Shopping Experience Easier, Faster and
												More Powerfull.
											</li>
											<li>
												You Can Save Your Time, you don't have to type in your details every
												time you checkout.
											</li>
											<li>You Can See Your Order History.</li>
											<li>Be the First to know about Offers, New Products updates.</li>
											<li>For any Technical Issue Call on +91-9990903066</li>
										</ol>
										<div className="visible-xs topmargin" />
										<p className="nobottommargin well ng-hide">
											Already a member with us?{' '}
											<span
												className="withoutSpanherf button button-black"
												onClick={this.GotoSingin}
											>
												<span className="t700">
													<em>Login</em>
												</span>
											</span>
										</p>
									</div>
								) : (
									''
								)}
								{this.state.panel === 2 ? (
									<div className="col-md-offset-1 col-md-5 col-sm-6">
										<div className="visible-lg visible-md topmargin" />
										<h2>Welcome To Printster.in</h2>
										<ul>
											<li>
												An Account With us Makes your Shopping Experience Easier, Faster and
												More Powerfull.
											</li>
											<li>
												You Can Save Your Time, you don't have to type in your details every
												time you checkout.
											</li>
											<li>You Can See Your Order History.</li>
											<li>Be the First to know about Offers, New Products updates.</li>
											<li>For any Technical Issue Call on +91-9990903066</li>
										</ul>
										<div className="visible-xs topmargin" />
										<p className="nobottommargin well topmargin">
											{' '}
											<span className="t700">
												<em>
													Don't have an Account?{' '}
													<span
														className="withoutSpanherf button button-black"
														onClick={this.GotoSingup}
													>
														Signup now
													</span>{' '}
												</em>
											</span>
										</p>
									</div>
								) : (
									''
								)}
								{this.state.panel === 3 ? (
									<div
										className="col-md-offset-1 col-md-5 col-sm-6 ng-hide"
										ng-show="Signup.Wins == 2"
									>
										<div className="visible-lg visible-md topmargin" />
										<h2>Steps to Follow for Forgotten Password?</h2>
										<ol>
											<li>Enter Your Email or Mobile Number in the form.</li>
											<li>You Will Recieve OTP on your Mobile Number.</li>
											<li>Then Insert OTP in the Form.</li>
											<li>Now you will able to reset your Password.</li>
											<li>For any Technical Issue Call on +91-9990903066</li>
										</ol>
										<div className="visible-xs topmargin" />
									</div>
								) : (
									''
								)}
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}
export default singup;
